export default "__VITE_ASSET__b333bb17__"